import connector from '@/utils/Connection'

export default {
  actions: {
    async getPatientsD4W({dispatch, commit}) {
      const result = await connector.getPatientsD4W();
      this.state.lastResponse = result;
      if (result.error == 0) {
        this.state.patientsD4WList = result.data;
      }
      return result;
    }
  }
}